import React from 'react'
import { FormButton } from '@myxplor/forms'
import Icon from './icon'

const GovActionToggleButton = ({ toggle, icon, label, right = false }) => (
  <FormButton right={right} className="govListActions--toggle" onClick={toggle}>
    <Icon icon={icon} />
    {label}
  </FormButton>
)

export default GovActionToggleButton



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/toggle-button.jsx